export const baseUrl:string = "https://smsmessage.cfif31.ru/api"